/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Gallery_LimitInputs */

const cs_gallery_limit = /** @type {(inputs: Gallery_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Maximum ${i?.max} fotek`)
};

const en_gallery_limit = /** @type {(inputs: Gallery_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Maximum ${i?.max} photos`)
};

/**
* | output |
* | --- |
* | "Maximum {max} photos" |
*
* @param {Gallery_LimitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_limit = /** @type {((inputs: Gallery_LimitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_LimitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_limit(inputs)
	return cs_gallery_limit(inputs)
});